class TruncateText extends HTMLElement {
  selectors = {
    text: '[data-truncate-text-el="text"]',
    original: '[data-truncate-text-el="original"]',
    cta: '[data-truncate-text-el="cta"]',
  }

  els = {
    text: this.querySelector(this.selectors.text),
    original: this.querySelector(this.selectors.original),
    cta: this.querySelector(this.selectors.cta),
  }

  connectedCallback () {
    const maxLength = 14

    if (!this.els.text || !this.els.cta) {
      this.show()
      return
    }

    if (this.els.original.querySelector('div')) {
      this.els.original = this.els.original.querySelector('div')
    }

    if (this.els.text.textContent.split(' ').length > maxLength) {
      this.truncateText(this.els.text, this.els.text.textContent, maxLength)
      this.setupEventListeners()
    }
    this.show()
  }

  setupEventListeners () {
    this.els.cta.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick () {
    const extraText = document.querySelector('[data-truncate-text-el="hidden-text"]')

    if (extraText) {
      this.els.text.innerHTML = this.els.original.innerHTML

      window.dataLayer.push({
        event: 'plp_expand_header_text',
      })
    }
  }

  show () {
    this.classList.remove('hidden')
  }

  truncateText (el, text, maxLength) {
    const words = text.split(' ')
    const truncatedContent = words.slice(0, maxLength).join(' ')

    el.textContent = truncatedContent

    el.insertAdjacentHTML('beforeend', '... <span data-ga-el="plp-description-more" class="collection-hero__description--more">Read More</span>')
    el.insertAdjacentHTML('beforeend', `<div data-truncate-text-el="hidden-text" class="truncate-text__more-text hidden">${this.els.original.innerHTML}</div>`)
  }
}

customElements.define('truncate-text', TruncateText)
